module.exports = __webpack_public_path__ + "img/10_no.a3bf13f6.svg";